'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('alignSelf', 'alignSelf');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/align-self.js
// module id = 648
// module chunks = 3